if (!customElements.get('academy-offer-purchase')) {
  class AcademyOfferPurchase extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.variantInput = this.querySelector('.academy-offer-product__variant-id');
      this.price = this.querySelector('[data-purchase-price]');
      this.note = this.querySelector('[data-purchase-note]');
      this.submit = this.querySelector('[data-purchase-submit]');
      this.submitLabel = this.querySelector('[data-purchase-submit-label]');
      this.productRoot = this.closest('.academy-offer-product');
      this.sourceProperty = this.querySelector('[data-academy-source-property]');
      this.placementProperty = this.querySelector('[data-academy-placement-property]');
      this.kitProperty = this.querySelector('[data-academy-kit-property]');
      this.attribution = this.readAttribution();

      if (this.sourceProperty) this.sourceProperty.value = this.attribution.source;
      if (this.placementProperty) this.placementProperty.value = this.attribution.placement;

      this.querySelectorAll('[data-variant-choice], [data-selling-plan-choice], [data-offer-preview-choice]').forEach((input) => {
        input.addEventListener('change', () => this.update(input));
      });

      this.form?.addEventListener('submit', () => {
        this.syncPurchaseFields();
        this.track('academy_checkout_click', this.currentTrackingPayload());
        this.track('academy_add_to_cart', {
          ...this.currentTrackingPayload(),
          checkout_redirect: true
        });
      });
      this.form?.addEventListener('formdata', (event) => {
        this.syncPurchaseFields(event.formData);
      });

      const recurpayObserver = new MutationObserver(() => this.disableDuplicateRecurpayFields());
      recurpayObserver.observe(this, { childList: true, subtree: true });
      this.disableDuplicateRecurpayFields();

      const initialPlan = this.querySelector('[data-selling-plan-choice]:checked');
      const initialVariant = this.querySelector('[data-variant-choice]:checked');
      const initialPreview = this.querySelector('[data-offer-preview-choice]:checked');
      this.update(initialPlan || initialPreview || initialVariant);
      this.track('academy_product_view', this.currentTrackingPayload());
    }

    track(eventName, payload = {}) {
      const eventPayload = {
        ...payload,
        event_version: 'conversion-sprint-2026-09-27'
      };
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: eventName,
        ...eventPayload
      });
      if (window.Shopify?.analytics?.publish) {
        window.Shopify.analytics.publish(eventName, eventPayload);
      }
    }

    readAttribution() {
      const params = new URLSearchParams(window.location.search);
      let stored = {};
      try {
        stored = JSON.parse(sessionStorage.getItem('academy_funnel_attribution') || '{}');
      } catch (error) {}

      return {
        source: params.get('academy_ref') || stored.placement || 'direct',
        placement: stored.placement || params.get('academy_ref') || 'product_page',
        selected_offer: params.get('academy_offer') || stored.offer || ''
      };
    }

    currentTrackingPayload() {
      const selectedPreview = this.querySelector('[data-offer-preview-choice]:checked');
      const selectedPlan = this.querySelector('[data-selling-plan-choice]:checked');
      const selectedVariant = this.querySelector('[data-variant-choice]:checked');
      const variantId = selectedPreview?.dataset.variantId || selectedVariant?.value || this.variantInput?.value || '';
      const priceLabel = selectedPlan?.dataset.priceLabel || selectedPreview?.dataset.priceLabel || selectedVariant?.dataset.priceLabel || this.price?.textContent?.trim() || '';
      const planLabel = selectedPlan?.closest('label')?.querySelector('strong')?.textContent.trim() || '';
      const optionLabel = selectedPreview?.closest('label')?.querySelector('strong')?.textContent.trim() || selectedVariant?.closest('label')?.querySelector('strong')?.textContent.trim() || '';

      return {
        offer: this.productRoot?.dataset.offer || '',
        product_id: this.productRoot?.dataset.productId || '',
        product_handle: this.productRoot?.dataset.productHandle || '',
        product_title: this.productRoot?.dataset.productTitle || '',
        variant_id: variantId,
        price_label: priceLabel,
        selling_plan_id: selectedPlan?.value || '',
        selling_plan_label: planLabel,
        option_label: optionLabel,
        source: this.attribution.source,
        placement: this.attribution.placement,
        selected_offer: this.attribution.selected_offer,
        url: window.location.pathname
      };
    }

    disableDuplicateRecurpayFields() {
      if (!this.closest('.academy-offer-product[data-offer="academy"]')) return;

      this.querySelectorAll('.recurpay-pdp-widget input, .recurpay-pdp-widget select, .recurpay-pdp-widget button').forEach((field) => {
        field.disabled = true;
      });
    }

    syncPurchaseFields(formData) {
      const selectedPreview = this.querySelector('[data-offer-preview-choice]:checked');
      const selectedPlan = this.querySelector('[data-selling-plan-choice]:checked');
      const selectedVariantId = selectedPreview?.dataset.variantId || this.variantInput.value;

      if (selectedPreview?.dataset.variantId) {
        this.variantInput.value = selectedVariantId;
      }

      this.disableDuplicateRecurpayFields();

      if (!formData) return;

      formData.set('id', selectedVariantId);
      if (selectedPlan) {
        formData.set('selling_plan', selectedPlan.value);
      }
    }

    update(changedInput) {
      if (!changedInput) return;

      if (changedInput.matches('[data-variant-choice]')) {
        this.variantInput.value = changedInput.value;
        const available = changedInput.dataset.available === 'true';
        this.submit.disabled = !available;
        this.submitLabel.textContent = available ? (this.submit.dataset.activeLabel || 'Acquista ora') : 'Esaurito';
      }

      const selectedPlan = this.querySelector('[data-selling-plan-choice]:checked');
      const selectedPreview = this.querySelector('[data-offer-preview-choice]:checked');
      const selectedVariant = this.querySelector('[data-variant-choice]:checked');
      const priceSource = selectedPlan || selectedPreview || selectedVariant;

      if (priceSource?.dataset.priceLabel) {
        this.price.textContent = priceSource.dataset.priceLabel;
      }

      if (selectedPreview) {
        if (this.kitProperty) {
          this.kitProperty.value = selectedPreview.dataset.kitLabel || '';
          this.kitProperty.disabled = !selectedPreview.dataset.kitLabel;
        }
        this.note.textContent = selectedPreview.dataset.summaryNote;
        if (selectedPreview.dataset.variantId) {
          this.variantInput.value = selectedPreview.dataset.variantId;
        }
        const checkoutEnabled = selectedPreview.dataset.checkoutEnabled === 'true' && Boolean(selectedPreview.dataset.variantId);
        this.submit.disabled = !checkoutEnabled;
        this.submitLabel.textContent = checkoutEnabled ? (this.submit.dataset.activeLabel || 'Acquista ora') : 'Formula esaurita';
      } else if (selectedPlan) {
        const planName = selectedPlan.closest('label')?.querySelector('strong')?.textContent.trim().toLowerCase() || '';
        if (planName.includes('annuale')) {
          this.note.textContent = `${selectedPlan.dataset.perDeliveryLabel}/mese equivalente`;
        } else {
          this.note.textContent = 'Rinnovo mensile';
        }
      } else if (this.note) {
        this.note.textContent = 'Pagamento unico';
      }

      this.syncPurchaseFields();
      this.track('academy_offer_option_change', this.currentTrackingPayload());
    }
  }

  customElements.define('academy-offer-purchase', AcademyOfferPurchase);
}
